<script setup lang="ts">
import { formatReviewCount } from '@/features/reviews';
import { type FragmentType, graphql } from '@/gql';
import { useRoutes } from '@glow/shared/lib/routes';

const { getUrl } = useRoutes();
const masterFragment = graphql(/* GraphQL */ `
  fragment FeaturedMasterPreview_MasterFragment on Master {
    id
    slug
    avatarUrl
    fullName
    reviewCount
    rating
    workPlaces {
      id
      city {
        id
        slug
      }
    }
    specializations {
      specialization {
        name
      }
    }
  }
`);

const props = defineProps<{
  master: FragmentType<typeof masterFragment>;
}>();
const master = useFragmentData(masterFragment, () => props.master);
const { value: specializations, collapsedLength: specializationLength } =
  useCollapsibleArray(
    // () =>
    //   master.value.specializations.map(
    //     (specialization) => specialization.specialization.name
    //   ),
    ['Депиляция сахаром (Шугаринг)', 'Депиляция воском', 'asdf'],
    2,
    true
  );
const expandSpecializationText = toRef(() =>
  specializationLength.value ? `Ещё ${specializationLength.value}` : undefined
);
</script>

<template>
  <NuxtLink
    :key="master.id"
    :to="
      getUrl('partnerDetails', {
        city: master.workPlaces[0].city.slug,
        type: 'master',
        partner: master.slug,
      })
    "
    class="item"
  >
    <AppAvatar class="avatar" :src="master.avatarUrl" :name="master.fullName" />
    <div class="item-content">
      <div class="name">{{ master.fullName }}</div>
      <div class="d-flex align-items-center gap-1">
        <AppRating :model-value="master.rating" />
        <span class="text-primary">
          {{ formatReviewCount(master.reviewCount) }}
        </span>
      </div>
      <div class="profession">
        {{ specializations.join(' • ') }}
        <span v-if="expandSpecializationText" class="text-primary">
          {{ expandSpecializationText }}
        </span>
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped lang="scss">
.item {
  display: flex;
  gap: 12px;
  padding: 16px;
  font-size: 15px;
  line-height: 20px;
  background: var(--app-color-white-secondary);
  color: var(--app-color-black);
  border-radius: 12px;
}

.avatar {
  flex-shrink: 0;
}

.item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profession {
  color: var(--app-color-black-secondary);
}

.name {
  font-weight: 600;
}
</style>
